import React from 'react';
import './Button.css';

/**
 * Button Component
 *
 * @param {string} variant - 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger'
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {boolean} fullWidth - Makes button full width
 * @param {boolean} loading - Shows loading spinner
 * @param {boolean} disabled - Disables the button
 * @param {ReactNode} leftIcon - Icon on the left
 * @param {ReactNode} rightIcon - Icon on the right
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled = false,
  leftIcon,
  rightIcon,
  className = '',
  type = 'button',
  onClick,
  ...props
}) => {
  const classNames = [
    'oz-btn',
    `oz-btn--${variant}`,
    `oz-btn--${size}`,
    fullWidth && 'oz-btn--full-width',
    loading && 'oz-btn--loading',
    disabled && 'oz-btn--disabled',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classNames}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && (
        <span className="oz-btn__spinner">
          <svg viewBox="0 0 24 24" fill="none" className="animate-spin">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="31.416" strokeDashoffset="10" />
          </svg>
        </span>
      )}
      {!loading && leftIcon && <span className="oz-btn__icon oz-btn__icon--left">{leftIcon}</span>}
      <span className="oz-btn__text">{children}</span>
      {!loading && rightIcon && <span className="oz-btn__icon oz-btn__icon--right">{rightIcon}</span>}
    </button>
  );
};

export default Button;
